import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import LcIcon from '../../../../components/Generic/LcIcon';
import LcLoading from '../../../../components/Generic/LcLoading';
import SolicitationService from '../../../../services/SolicitationService/SolicitationService';
import { RootState } from '../../../../store';
import { UserState } from '../../../../store/reducers/userReducer';
import { Selection } from '../../../../models/Selection';
import LcInfiniteTable from '../../../../components/Data/LcInfiniteTable';
import { SolicitationView } from '../../../../models/SolicitationView';
import SolicitationAttendantService from '../../../../services/SolicitationAttendantService/SolicitationAttendantService';
import DynamicTableGroupAndColumnBuilder from '../../../../services/DynamicTableGroupAndColumnBuilder/DynamicTableGroupAndColumnBuilder';
import AttendanceSlaSloBar from '../../AttendanceSlaSloBar';
import StatusColorDisplay from '../../../../components/Generic/StatusColorDisplay';
import RequesterDisplay from '../../../../components/Generic/RequesterDisplay';

interface PropsSolicitationViewList {
    solicitation: any;
    refreshParentAction?: Function,
    handleRefreshData: Function
    handleLength: Function
}

export const LinkedSolicitations: React.FC<PropsSolicitationViewList> = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const [solicitationAttendantService, setSolicitationAttendantService] = useState<SolicitationAttendantService>(new SolicitationAttendantService(props));
    const [solicitationDynamicTableGroupAndColumnBuilder, setDynamicTableGroupAndColumnBuilder] = useState<DynamicTableGroupAndColumnBuilder>(new DynamicTableGroupAndColumnBuilder());
    const [solicitationService, setSolicitationService] = useState<SolicitationService>(new SolicitationService(props));
    const [SolicitationViewsList, setSolicitationViewsList] = useState<SolicitationView[]>([]);
    const [columns, setColumns] = useState<object[]>([
        solicitationDynamicTableGroupAndColumnBuilder.getColumnRenderCell('statusIcon'),
        solicitationDynamicTableGroupAndColumnBuilder.getColumnRenderCell('workName'),
        solicitationDynamicTableGroupAndColumnBuilder.getColumnRenderCell('id'),
        solicitationDynamicTableGroupAndColumnBuilder.getColumnRenderCell('nameUserRequester'),
        solicitationDynamicTableGroupAndColumnBuilder.getColumnRenderCell('sla_slo'),
        solicitationDynamicTableGroupAndColumnBuilder.getColumnRenderCell('nameResponsibleUser'),
        solicitationDynamicTableGroupAndColumnBuilder.getColumnRenderCell('idStatus'),
    ]);
    const [loading, setLoading] = useState<boolean>(false);
    const [SolicitationViewSelectionList, setSolicitationViewSelectionList] = useState<Selection[]>([]);
    const [filteredSolicitationViewsList, setFilteredSolicitationViewsList] = useState<SolicitationView[]>([]);
    const [search, setSearch] = useState<string>("");
    const getSearch = (search: string) => setSearch(search);

    const columns2 = [
        {
            field: "statusIcon",
            headerName: "",
            width: "5%",
            align: "left",
            renderCell: (row: any) => {
                const solicitationService = new SolicitationService(row);

                const statusIcon = row.statusIcon;

                let statusDescription = solicitationService.statusList.find(x => x.value === row.idStatus.toString())?.label;
                statusDescription = (statusDescription) ? statusDescription : "";

                const workStatus = solicitationService.workStatus.find(x => x.id === row.workStatus);

                const workStatusIcon = (workStatus) ? workStatus.icon : "";
                let workStatusDescription = (workStatus) ? workStatus.label : "";

                if (statusDescription.endsWith("a") && statusDescription !== "Em pausa" && statusDescription !== "Aguardando outra área") {
                    statusDescription = statusDescription.substring(0, statusDescription.length - 1) + "o";
                }

                if (workStatusDescription.endsWith("a") && workStatusDescription !== "Em pausa" && workStatusDescription !== "Aguardando outra área") {
                    workStatusDescription = workStatusDescription.substring(0, workStatusDescription.length - 1) + "o";
                }

                return <LcIcon icon={row.statusIcon} color='grey' />
            }
        },
        {
            field: "workName",
            headerName: "Assunto do Trabalho",
            width: "22%",
            align: "left",
        },
        {
            field: "id",
            headerName: "N° Sol.",
            width: "10%",
            align: "left",
        },
        {
            field: 'nameUserRequester',
            headerName: 'Solicitante',
            width: "19%",
            align: "left",
        },
        {
            field: 'sla_slo',
            headerName: 'SLA / SLO',
            width: "10%",
            align: "left",
            renderCell: (row: any) => {
                return <AttendanceSlaSloBar solicitation={row} width={"100px"} height={"4px"} />
            }
        },
        {
            field: "nameResponsibleUser",
            headerName: "Atendente",
            width: "19%",
            align: "left",
            renderCell: (row: any) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <RequesterDisplay row={row} />
                    </div>
                )
            }
        },
        {
            field: "idStatus",
            headerName: "Status Solicitação",
            width: "15%",
            align: "left",
            renderCell: (row: any) => {
                return <StatusColorDisplay row={row} type={"solicitation"} />
            }
        },
    ];

    useEffect(() => {
        if (props.solicitation) {
            retrieveData();
        }
    }, [props.solicitation]);

    const retrieveData = async () => {
        setLoading(true);

        try {
            var list = await solicitationAttendantService.GetLinkedSolicitation(props.solicitation.id);
            let testeList: any[] = [];

            list.sort((a: SolicitationView, b: SolicitationView) => a.idWork < b.idWork ? 1 : -1)
                .map(x => {
                    const teste = testeList.find(y => y.id == x.id);
                    if (teste == undefined) testeList.push(x);
                })

            let activeWorks = testeList;
            // let activeWorks = list.filter(work => work.workStatus !== 7 && work.workStatus !== 8 && work.workStatus !== 6)

            props.handleLength(activeWorks.length)
            //const openList = list.filter((x: SolicitationViewView) => x.idStatus !== 6 && x.idStatus !== 7 && x.idStatus !== 8)
            //    .sort((a: SolicitationViewView, b: SolicitationViewView) => moment(a.startDate) > moment(b.startDate) ? 1 : -1);
            //const closedList = list.filter((x: SolicitationViewView) => x.idStatus === 6 || x.idStatus === 7 || x.idStatus === 8)
            //    .sort((a: SolicitationViewView, b: SolicitationViewView) => moment(a.endDate) < moment(b.endDate) ? 1 : -1);

            setSolicitationViewsList(activeWorks);
            setFilteredSolicitationViewsList(activeWorks);

            // setSelectedEditRow(undefined);
            // props.handleRefreshData(activeWorks, "linked");
        }
        catch (e) {
            debugger;
        }

        setLoading(false);
    }

    const onChangeSelectionSolicitationViews = (selection: any) => {
        //setSelectedEditRow(undefined);

        //if (selection.fields[0].value == "mais") {
        //    let filtered: SolicitationViewView[] = [];

        //    SolicitationViewSelectionList.map(SolicitationViewSelection => {
        //        let temp = SolicitationViewsList.find(x => x.id.toString() == SolicitationViewSelection.fields[0].value);

        //        if (temp != undefined) filtered.push(temp);
        //    })

        //    setFilteredSolicitationViewsList(filtered);
        //}
        //else {
        //    const busca = selection.fields[0].value;

        //    const filtered = SolicitationViewsList.filter((x: SolicitationViewView) => x.id.toString().toLowerCase() == busca)
        //    setFilteredSolicitationViewsList(filtered);
        //}
    }



    useEffect(() => {
        if (search != "") {
            let SolicitationViewSelectionList: Selection[] = [];

            //const SolicitationViewsListFiltered = SolicitationViewsList.filter((x: SolicitationViewView) => x.subject.includes(search));

            //SolicitationViewsListFiltered.map((SolicitationView: any) => {

            //    let SolicitationViewSelectionList_ = templateDefault;

            //    if (SolicitationView.description == null) {
            //        SolicitationView.description = "";
            //    }

            //    const detailsLength = SolicitationView.description.length;

            //    const details = (detailsLenght <= 300) ? SolicitationView.description : SolicitationView.description.substring(0, 300) + " (...)";

            //    SolicitationViewSelectionList_ = {
            //        label: "> " + SolicitationView.id + " - " + SolicitationView.subject + " - " + details,
            //        text: SolicitationView.subject,
            //        fields: [
            //            {
            //                name: SolicitationView.subject,
            //                value: SolicitationView.id.toString()
            //            }
            //        ]
            //    }

            //    SolicitationViewSelectionList.push(SolicitationViewSelectionList_);
            //})

            setSolicitationViewSelectionList(SolicitationViewSelectionList);
        }
        else {
            setSolicitationViewSelectionList([]);
            setFilteredSolicitationViewsList(SolicitationViewsList);
        }

    }, [search]);

    const functionGeneric = [
        {
            title: 'Filtro',
            icon: 'ppi ppi-search',
            isFilter: true,
            isFilterCampo: {
                contents: SolicitationViewSelectionList.slice(0, 7),
                onChange: onChangeSelectionSolicitationViews,
                onChangePesquisa: getSearch,
            }
        },
        {
            title: '',
            icon: 'ppi ppi-divider-vertical',
            iconDisabled: {
                color: "#B5B7C6",
                tooltip: "",
                disabled: true,
            },
            tooltip: '',
            func: () => {
            }
        },
        {
            title: 'Atualizar solicitações vinculadas',
            icon: 'ppi ppi-refresh',
            tooltip: 'Atualizar solicitações vinculadas',
            func: () => {
                retrieveData();
            }
        },
    ];

    const getStatus = (row: any) => {
        let urgency = solicitationService.urgency.find(x => x.id === row.urgency);
        return (urgency) ? urgency.color : "#FAFAFA";
    }

    return (
        <>
            <LcLoading loading={loading} label="Carregando..." >
                {
                    filteredSolicitationViewsList &&
                    <LcInfiniteTable
                        functionGeneric={functionGeneric}
                        status={getStatus}
                        rows={filteredSolicitationViewsList}
                        size={SolicitationViewsList.length}
                        columns={columns2}
                        loadMore={() => { }}
                        linked={true}
                        rowLinkClick={true}
                    />
                }
            </LcLoading>
        </>
    );
};